import { IFarmState } from './IFarmState';

export const initialFarmState: IFarmState = {
    constructionModeEnabled: false,
    previewSlots: {},
};
